import { jsx as _jsx } from "react/jsx-runtime";
import { LORAX } from 'HubStyleTokens/colors';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Flow } from 'signup-constants/Flow';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILogo from 'UIComponents/image/UILogo';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { getFlowKey } from '../routing/getFlowKey';
import { getCurrentStep } from '../store/flow/selectors';
import { useTracker } from '../tracking/useTracker';
import { AcademyLogo, getAcademyLogoConfig } from './AcademyLogo';
import { ChatSpotLogo, getChatspotLogoConfig } from './ChatSpotLogo';
import { ConnectLogo, getConnectLogoConfig } from './ConnectLogo';
const HubSpotWordmark = styled(UILogo).withConfig({
  displayName: "HubSpotLogo__HubSpotWordmark",
  componentId: "sc-11u9r0c-0"
})(["display:inline-block;width:8rem;"]);
const HubSpotSprocket = styled(UIIcon).withConfig({
  displayName: "HubSpotLogo__HubSpotSprocket",
  componentId: "sc-11u9r0c-1"
})(["width:27px;height:27px;transform:translateY(7px);"]);
const flowsWithSpecificLogos = {
  [Flow.Connect]: /*#__PURE__*/_jsx(ConnectLogo, {}),
  [Flow.Academy]: /*#__PURE__*/_jsx(AcademyLogo, {}),
  [Flow.ChatSpot]: /*#__PURE__*/_jsx(ChatSpotLogo, {})
};
const SpecificLogoConfig = {
  [Flow.Connect]: getConnectLogoConfig,
  [Flow.Academy]: getAcademyLogoConfig,
  [Flow.ChatSpot]: getChatspotLogoConfig
};
export const getSpecificLogoConfig = isMobile => {
  const flowKey = getFlowKey();
  let url;
  let altText = 'Hubspot';
  const getSpecificLogoConfigFunction = SpecificLogoConfig[flowKey];

  if (getSpecificLogoConfigFunction) {
    const logoConfig = getSpecificLogoConfigFunction(isMobile);
    url = logoConfig.url;
    altText = logoConfig.altText;
  }

  return {
    url,
    altText
  };
};

const HubSpotLogo = () => {
  const flowKey = getFlowKey();
  const Tracker = useTracker();
  const currentStep = useSelector(getCurrentStep);
  const {
    isDesktop
  } = useResponsiveness();
  const showSprocketCheck = getFlowConfig().shouldShowSprocket;

  const onClick = () => {
    Tracker.signupInteraction('click-hubspot-company-logo', {
      currentStep
    }, true);
  };

  const hubSpotLogo = /*#__PURE__*/_jsx(HubSpotWordmark, {
    alt: "Hubspot",
    name: "hubspot-wordmark",
    width: "128"
  });

  const shouldShowSprocket = !isDesktop && showSprocketCheck;

  const renderLogo = () => {
    if (isDesktop) {
      return flowsWithSpecificLogos[flowKey] ? flowsWithSpecificLogos[flowKey] : hubSpotLogo;
    } else return shouldShowSprocket ? /*#__PURE__*/_jsx(HubSpotSprocket, {
      color: LORAX,
      flowkey: flowKey,
      name: "sprocket",
      size: 27
    }) : flowsWithSpecificLogos[flowKey];
  };

  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      onClick: onClick,
      children: renderLogo()
    })
  });
};

export default HubSpotLogo;